import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
import "vant/es/checkbox-group/style";
import _CheckboxGroup from "vant/es/checkbox-group";
import "vant/es/submit-bar/style";
import _SubmitBar from "vant/es/submit-bar";
import "vant/es/checkbox/style";
import _Checkbox from "vant/es/checkbox";
import "vant/es/card/style";
import _Card from "vant/es/card";
import "vant/es/image/style";
import _Image from "vant/es/image";

var _components;

import "core-js/modules/es.function.name.js";
import integralSignIn from "./integralSignIn";
import { mapMutations, mapState } from "vuex";
export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: ""
    },
    isHome: {
      type: Boolean,
      default: false
    },
    rebackHome: {
      type: Boolean,
      default: false
    },
    leftText: {
      type: String,
      default: ""
    },
    canSignIn: {
      type: Boolean,
      default: false
    },
    headerBackground: {
      type: String,
      default: "#fff"
    },
    border: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    },
    isPush: {
      type: Boolean,
      default: false
    },
    isNav: {
      type: Boolean,
      default: true
    }
  },
  components: (_components = {}, _defineProperty(_components, _Image.name, _Image), _defineProperty(_components, _Card.name, _Card), _defineProperty(_components, _Checkbox.name, _Checkbox), _defineProperty(_components, _SubmitBar.name, _SubmitBar), _defineProperty(_components, _CheckboxGroup.name, _CheckboxGroup), _defineProperty(_components, _NavBar.name, _NavBar), _defineProperty(_components, _Toast.name, _Toast), _defineProperty(_components, "integralSignIn", integralSignIn), _components),
  data: function data() {
    return {
      fixTopValue: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["isTest", "shareTitle", "shareDesc", "shareImage", "bannerImage"])), {}, {
    isProduction: function isProduction() {
      return !this.isHome || process.env.NODE_ENV === "production";
    },
    fixTop: function fixTop() {
      return this.fixTopValue;
    },
    headerTitle: function headerTitle() {
      if (this.title) {
        return this.title;
      } else {
        return "";
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations(["setAppInfo"])), {}, {
    onClickLeft: function onClickLeft() {
      if (this.isHome) {
        goFinish();
      }

      if (this.rebackHome) {
        this.$router.push("/");
      } else {
        var currentPath = window.location.pathname;
        this.$router.back();
        setTimeout(function () {
          if (currentPath === window.location.pathname) {
            goBack();
          }
        }, 200);
      }
    },
    onClickLogo: function onClickLogo() {
      window.location.href = "https://m.d1ev.com/";
    },
    onClickRight: function onClickRight() {
      var _document$querySelect;

      //Toast("按钮");
      var shareUrl = "";

      if (this.isTest) {
        shareUrl = "https://www.d1ev.com/special/spring-activity/share-test.html";
      } else {
        shareUrl = "https://www.d1ev.com/special/spring-activity/share.html";
      }

      var param = {
        "title": this.shareTitle || "每日抢积分 邀请送豪礼 - 第一电动",
        "thumbImage": this.shareImage || "https://www.d1ev.com/special/circle/images/share-2.png",
        "description": this.shareDesc || ((_document$querySelect = document.querySelector("meta[name='description']")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content) || "",
        "url": shareUrl
      };
      param.url ? window.startShare(param) : "";
    }
  }),
  mounted: function mounted() {
    if (topBarHeight) {
      this.fixTopValue = topBarHeight;
    }
  }
};